import { AccountViewModel } from '@models/account.class';

export enum LegalPersonalityType {
  natural = 1,
  legal = 2,
}

export enum IContractType {
  Fis_Mex_R_en_Mex = 1,
  Fis_Mex_R_en_Ext = 2,
  Fis_Ext_R_en_Mex = 3,
  Moral_Mexicana = 4,
  Moral_Extranjera = 5,
  Banco = 6,
  Mun_Ent_y_Org_Pub = 7,
  Fo_Ahorro_Pens_y_Jub = 8,
  Fideicomiso_Fisicas = 9,
  Casa_de_Bolsa = 10,
  Pos_Propia_M_Dinero = 11,
  Pos_Propia_M_Capital = 12,
  Fis_Ext_R_en_Ext = 13,
  Contrato_Operativo_M = 14,
  Soc_Finan_de_Obj_Lim = 15,
  Cobertura_Warrants = 16,
  Fis_MR_en_Mex_A_Emp = 17,
  Fideicomiso_Morales = 18,
  Soc_Inv_Interna = 19,
  Afore = 20,
  Soc_Inv_Externa = 21,
  Asociacion_Fundacion = 22,
  Administrativo = 23,
  Operativo_Derivados = 24,
  Org_Aux_de_Credito = 25,
  Intermediario_Ext = 26,
  Banco_Extranjero = 98,
  Proveedor_de_Mercado = 99,
  Arbitraje_Internacio = 253,
  Op_Ord_Globales = 254,
  Op_Ord_Oportunidad = 255,
}

export enum IManagementType {
  USA = 100,
}

/**
 * FIXME: Duplicated definition
 */
export interface IContract {
  managementType: IManagementType;
  isUsa: boolean;
  memberSince: string;
  partyType: number;
  affiliateTypeId: number;
  clientType: number;
  contractType: IContractType;
  active: boolean;
  isppr: boolean;
  spreadLimit: number;
  tradeSIC: boolean;
  profile: number;
  tradeShortSell: boolean;
  contractID: string;
  totals: Totals;
  legalPersonalityType: LegalPersonalityType;
  tradeMargin: boolean;
  properties: Properties;
  contractGender: number;
  canOperate: boolean;
  isGBMEmployee: boolean;
  clientName: string;
  commissionBuy: number;
  birthDay: string;
  commissionSell: number;
  isReadOnly: boolean;
  isDiscretional: boolean;
  isPPR: boolean;
  isReadOnlyByRelationship?: boolean; // This value is assigned from getContractsBP just after the data is retrieved
  isInLorem: boolean;
  isLoremAccount?: boolean; // This value is assigned from getContractsBP just after the data is retrieved
  isLoremAccountMigrated?: boolean; // This value is assigned from getContractsBP just after the data is retrieved
  loremAccountLoaded: boolean;
  loremAccountId: string;
  loremContractId: string;
  manageType: number;
  legacyContractId: string /** This value is assigned from {@link ContractsService.getAccountManagerElegibility} */;
}

export interface Properties {
  sellingPower: number;
  marginHB: number;
  contractRisk: ContractRisk;
}

export interface ContractRisk {
  pendingOrdersRisk: number;
  registeredOrdersValue: number;
  reportos: number;
  virtualSalesGBMF2: number;
}

export interface Totals {
  total: Total;
  gbmf2: number;
  cash: number;
  capitalMarketRisks: ContractRisk;
  buyingPower: number;
  margin: number;
  sellingPower: number;
  buyingPowerSecureAmount: number;
  buyingPowerMarginAmount: number;
}

export interface Total {
  marketValue: number;
}

export interface IBuyingPower {
  buyingPower: number;
  marketValueTotal: number;
  totalCash: number;
  tradeMargin: boolean;
  pendingOrdersRisk: number;
  virtualGBMF2: number;
  reporto: number;
}

export interface IContractResponse {
  contract_id: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  legacy_contract_id: string;
  contract_status: string;
  opening_type: string;
  is_legacy: boolean;
  created_at: string;
}

/**
 * FIXME: Duplicated definition
 */
export interface IContract {
  /**
   * !Warning: Check existence before using, may be undefined, try `contractID`
   */
  contractId: string;
  firstName: string;
  middleName: string;
  lastName: string;
  legacyContractId: string;
  contractStatus: string;
  openingType: string;
  isLegacy: boolean;
  createdAt: string;
}

export interface IContractAccountsCollection {
  contracts: {
    [contractId: string]: string[];
  };
  accounts: {
    [legacyAccountId: string]: AccountViewModel;
  };
  accountRelation: {
    [accountId: string]: string;
  };
}

export class ContractViewModel {
  private contractAccountsCollection: IContractAccountsCollection;

  constructor(public contractId: string, public accounts: AccountViewModel[]) {
    this.accounts = accounts;
    this.createAccountsCollection(accounts);
  }

  public setAccounts(accounts: AccountViewModel[]) {
    this.accounts = accounts;
    this.createAccountsCollection(accounts);
  }

  public hasAccount(legacyContractId: string) {
    return (
      this.contractAccountsCollection &&
      this.contractAccountsCollection.accounts[legacyContractId]
    );
  }

  public getContractAccountsCollection() {
    if (!this.accounts) {
      throw new Error('No accounts set yet');
    }
    return {
      ...this.contractAccountsCollection,
    };
  }

  private createAccountsCollection(accounts: AccountViewModel[]) {
    this.contractAccountsCollection = accounts.reduce(
      (collection, currentAccount) => {
        collection.contracts[this.contractId] = [
          ...(collection.contracts[this.contractId] || []),
          currentAccount.legacyContractId,
        ];

        collection.accounts[currentAccount.legacyContractId] = {
          ...currentAccount,
          contractId: this.contractId,
        } as AccountViewModel;

        collection.accountRelation[currentAccount.accountId] =
          currentAccount.legacyContractId;

        return collection;
      },
      {
        contracts: {},
        accounts: {},
        accountRelation: {},
      } as IContractAccountsCollection,
    );
  }
}
